import React, { useEffect, useMemo, useState } from 'react'

import {
  Box,
  CheckboxGroup,
  Checkbox,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  Input,
  Divider,
  Text,
} from '@chakra-ui/react'

const MultipleSelectFilter = ({ value, onChange, options }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [checkedItems, setCheckedItems] = useState(Array.isArray(value) ? value : [])
  const [optionFilter, setOptionFilter] = useState('')

  //Translated
  const allChecked = checkedItems.length === options.length
  const isIndeterminate = checkedItems.length > 0 && !allChecked
  const filteredOptions = options.filter((opt) => opt.label.toLowerCase().includes(optionFilter))

  const handleSetFilter = (data) => {
    setCheckedItems(data)
  }

  const handleSetActualFilter = () => {
    if (checkedItems.length === options.length) {
      //Set "All" which means no filter
      onChange(undefined)
    } else if (checkedItems.length === 0) {
      onChange(undefined)
    } else {
      onChange(checkedItems)
    }

    setIsOpen(false)
  }
  const handleSelectAll = () => {
    if (allChecked) {
      setCheckedItems([])
    } else {
      setCheckedItems(options.map((opt) => opt.value))
    }
  }

  const handleFilterOptions = (e) => {
    const filterString = e.target.value
    setOptionFilter(filterString)
    // console.log('filterString', filterString);
  }

  const handleClearAllFilter = () => {
    setCheckedItems([])

    setIsOpen(false)
    onChange(undefined)
  }

  const handleMenuClose = () => {
    setIsOpen(false)
    // setCheckedItems([]);
  }
  return (
    <Menu isOpen={isOpen} closeOnBlur onClose={handleMenuClose}>
      <MenuButton
        as={Button}
        bg={!value || value.length === 0 ? 'gray.100' : 'teal.500'}
        color={!value || value.length === 0 ? 'gray.600' : 'gray.50'}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {!value || value.length === 0 ? 'Filter' : '(Selected)'}
      </MenuButton>
      <MenuList zIndex="999" px="2" maxW="350px">
        <Flex direction="column" gap="3" px="4">
          <Input type="text" placeholder="Filter by" onChange={handleFilterOptions} variant={'solid'} />
          <Divider />
          <Checkbox
            colorScheme="teal"
            isChecked={allChecked}
            isIndeterminate={isIndeterminate}
            onChange={handleSelectAll}
          >
            All
          </Checkbox>
          <Box maxHeight="200px" overflowY={'scroll'}>
            <CheckboxGroup colorScheme="teal" value={checkedItems} onChange={handleSetFilter}>
              <Flex gap="3" direction={'column'}>
                {filteredOptions.map((option) => (
                  <Checkbox key={option.value} value={option.value}>
                    <Text textAlign={'start'}> {option.label}</Text>
                  </Checkbox>
                ))}
              </Flex>
            </CheckboxGroup>
          </Box>
          <Flex gap="2">
            <Button colorScheme="teal" onClick={handleSetActualFilter}>
              Apply
            </Button>
            <Button colorScheme="red" onClick={handleClearAllFilter}>
              Clear
            </Button>
          </Flex>
        </Flex>
      </MenuList>
    </Menu>
  )
}

export default React.memo(MultipleSelectFilter)
